import { Apartment, FactCheck, PrivacyTip, Report, VerifiedUser } from '@mui/icons-material';
import { Stack, styled } from '@mui/material';
import { BulkStatusDto } from 'models/dtoTypes';
import { useTranslation } from 'react-i18next';
const PREFIX = 'CompanyListVerificationTable';

const classes = {
  root: `${PREFIX}-root`,
  actions: `${PREFIX}-actions`,
  companyInfoCount: `${PREFIX}-companyInfoCount`,
  companyInfoVerified: `${PREFIX}-companyInfoVerified`,
  companyInfoSuccess: `${PREFIX}-companyInfoSuccess`,
  companyInfoError: `${PREFIX}-companyInfoError`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  lineHeight: '40px',
  [`& .${classes.companyInfoCount}`]: {
    color: theme.palette.primary.dark,
    fontWeight: 'bold',
  },
  [`& .${classes.companyInfoVerified}`]: {
    color: theme.palette.success.dark,
    fontWeight: 'bold',
  },
  [`& .${classes.companyInfoSuccess}`]: {
    color: theme.palette.secondary.dark,
    fontWeight: 'bold',
  },
  [`& .${classes.companyInfoError}`]: {
    color: theme.palette.error.dark,
    fontWeight: 'bold',
  },
}));

interface IProps {
  bulkStatus: BulkStatusDto | null;
}

export default function BulkStatusToolbar({ bulkStatus }: IProps) {
  const { t } = useTranslation('default');

  const { bulkSize = 0, scoringCounts, verificationCounts } = bulkStatus || {};

  const { scoringCompletedCount = 0, scoringErrorCount = 0 } = scoringCounts || {};

  const { verifiedCount = 0 } = verificationCounts || {};

  if (!bulkSize) {
    return null;
  }

  return (
    <Root>
      <Stack direction="row" spacing={2} justifyContent={'space-between'}>
        <Stack direction="row" spacing={2} justifyContent="flex-start" alignItems="center">
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoCount}
            title={String(t('total-count'))}
          >
            <Apartment /> {bulkSize}
          </Stack>
        </Stack>
        <Stack direction="row" spacing={2} justifyContent="flex-start" alignItems="center">
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoVerified}
            title={String(t('verification-complete'))}
          >
            <VerifiedUser /> {verifiedCount}
          </Stack>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoSuccess}
            title={String(t('verification-pending'))}
          >
            <PrivacyTip /> {bulkSize - verifiedCount}
          </Stack>
        </Stack>
        <Stack direction="row" spacing={2} justifyContent="flex-start" alignItems="center">
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoVerified}
            title={String(t('scoring-completed'))}
          >
            <FactCheck /> {bulkStatus?.scoringCounts?.scoringCompletedCount ?? 0}
          </Stack>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoSuccess}
            title={String(t('scoring-in-progress'))}
          >
            <FactCheck /> {bulkSize - scoringCompletedCount - scoringErrorCount}
          </Stack>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className={classes.companyInfoError}
            title={String(t('scoring-failed'))}
          >
            <Report /> {scoringErrorCount}
          </Stack>
        </Stack>
      </Stack>
    </Root>
  );
}
